import { MessageMention } from '@connect-x-app/shared-domain-models';
import { create } from 'zustand';

type MessageSessionStoreState = {
  clearMessage: () => void;
  clearSelectedMentions: () => void;
  hasLoadedLastPage: boolean;
  message: string;
  selectedMentions: MessageMention[];
  setHasLoadedLastPage: (hasLoadedLastPage: boolean) => void;
  setMessage: (newMessage: string) => void;
  setSelectedMentions: (mentions: MessageMention[] | ((prevState: MessageMention[]) => MessageMention[])) => void;
};

export const useMessageSessionStore = create<MessageSessionStoreState>(set => ({
  clearMessage: () => set({ message: '' }),
  clearSelectedMentions: () => set({ selectedMentions: [] }),
  hasLoadedLastPage: false,
  message: '',
  selectedMentions: [],
  setHasLoadedLastPage: hasLoadedLastPage => set({ hasLoadedLastPage }),
  setMessage: newMessage => set({ message: newMessage }),
  setSelectedMentions: mentions =>
    set(state => ({
      selectedMentions: typeof mentions === 'function' ? mentions(state.selectedMentions) : mentions,
    })),
}));
